"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_table_1 = require("react-table");
const components_1 = require("@/components");
const constants_1 = require("@/constants");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ColumnFilter = ({ column }) => {
    // @ts-ignore
    const { selectedFilter, setFilter } = column;
    react_1.useEffect(() => {
        setFilter(selectedFilter);
    }, [selectedFilter]);
    return react_1.default.createElement("span", null);
};
const ColumnHeader = ({ column, }) => {
    let toggle = null;
    if (column.sortable && column.isSorted) {
        if (column.isSortedDesc) {
            toggle = (react_1.default.createElement("img", { className: styles_scss_1.default.directionsDown, src: constants_1.Images.directionsDown, alt: "Toggle Sort" }));
        }
        else {
            toggle = react_1.default.createElement("img", { className: styles_scss_1.default.directionsUp, src: constants_1.Images.directionsUp, alt: "Toggle Sort" });
        }
    }
    else if (column.sortable) {
        toggle = react_1.default.createElement("img", { className: styles_scss_1.default.directions, src: constants_1.Images.directions, alt: "Toggle Sort" });
    }
    return (react_1.default.createElement("th", Object.assign({}, column.getHeaderProps(column.sortable ? column.getSortByToggleProps() : undefined)),
        react_1.default.createElement("div", { style: { display: 'flex' } },
            column.render('Header'),
            toggle),
        column.canFilter && react_1.default.createElement("div", null, column.render('Filter'))));
};
const Header = ({ getToggleAllRowsSelectedProps, }) => (react_1.default.createElement("div", { className: styles_scss_1.default.checkboxHeader },
    react_1.default.createElement(components_1.Checkbox, Object.assign({ ariaLabel: "Select/Unselect All" }, getToggleAllRowsSelectedProps(), { id: "select", name: "select" }))));
// @ts-ignore
const Cell = ({ row }) => (react_1.default.createElement("div", { className: styles_scss_1.default.checkboxCell },
    react_1.default.createElement(components_1.Checkbox, Object.assign({ ariaLabel: "Select Row" }, row.getToggleRowSelectedProps()))));
// eslint-disable-next-line max-lines-per-function
const Table = ({ columns, data, selectable, topComponent, loading, onChangeSelected, onSortChanged, onEndReached, }) => {
    const defaultColumn = react_1.useMemo(() => ({ Filter: ColumnFilter }), []);
    const tableColumns = react_1.useMemo(() => columns, [columns]);
    const tableData = react_1.useMemo(() => data, [data]);
    const tableInstance = react_table_1.useTable({
        columns: tableColumns,
        data: tableData,
        // @ts-ignore
        defaultColumn,
        manualSortBy: true,
    }, react_table_1.useFilters, react_table_1.useGlobalFilter, react_table_1.useSortBy, react_table_1.useRowSelect, react_table_1.useFlexLayout, hooks => {
        if (selectable) {
            hooks.visibleColumns.push((cols) => [
                {
                    id: 'selection',
                    Header,
                    // @ts-ignore
                    Cell,
                    width: 60,
                },
                ...cols,
            ]);
        }
    });
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, 
    // state,
    // @ts-ignore
    selectedFlatRows, 
    // @ts-ignore
    // setGlobalFilter,
    state: { sortBy }, } = tableInstance;
    react_1.useEffect(() => {
        if (onChangeSelected) {
            onChangeSelected(selectedFlatRows.map((row) => row.original));
        }
    }, [selectedFlatRows]);
    react_1.useEffect(() => {
        if (onSortChanged) {
            onSortChanged(sortBy);
        }
    }, [sortBy]);
    return (react_1.default.createElement("div", { className: styles_scss_1.default.tableWrapper },
        topComponent,
        react_1.default.createElement("table", Object.assign({}, getTableProps()),
            react_1.default.createElement("thead", null, headerGroups.map(headerGroup => (react_1.default.createElement("tr", Object.assign({}, headerGroup.getHeaderGroupProps(), { key: JSON.stringify(headerGroup.getHeaderGroupProps()) }), headerGroup.headers.map(column => (
            // @ts-ignore
            react_1.default.createElement(ColumnHeader, { key: column.id, column: column }))))))),
            react_1.default.createElement("tbody", Object.assign({}, getTableBodyProps()),
                react_1.default.createElement(components_1.Scrollable, { className: styles_scss_1.default.tableScrollable, onEndReached: () => {
                        if (onEndReached) {
                            onEndReached();
                        }
                    } },
                    loading && (react_1.default.createElement("div", { className: styles_scss_1.default.loadingIndicator },
                        react_1.default.createElement(components_1.CircularLoader, null))),
                    react_1.default.createElement(react_1.default.Fragment, null, rows.map(row => {
                        prepareRow(row);
                        return (react_1.default.createElement("tr", Object.assign({}, row.getRowProps(), { key: JSON.stringify(row.getRowProps()) }), row.cells.map(cell => (react_1.default.createElement("td", Object.assign({}, cell.getCellProps(), { key: JSON.stringify(cell.getCellProps()) }), cell.render('Cell'))))));
                    })))))));
};
Table.defaultProps = {
    selectable: false,
    searchable: false,
    topComponent: undefined,
    onFilterClick: undefined,
    onChangeSelected: undefined,
    onSortChanged: undefined,
    onEndReached: undefined,
    loading: false,
};
exports.default = Table;
